export default {
  landingNavigationSeoTitle: {
    id: 'landing_navigation_seo_title',
    defaultMessage: 'Categories',
  },
  price: {
    id: 'landing_price_filter_title',
    defaultMessage: 'Price',
  },
  sort: {
    id: 'landing_page_sort',
    defaultMessage: 'Sort',
  },
  navigate: {
    id: 'pagination_navigate',
    defaultMessage: 'Navigate to page {page}',
  },
  pagination: {
    id: 'pagination_label',
    defaultMessage: 'Product list pagination',
  },
}
